
const lawyer = {
  namespaced: true,
  state: {
    item: null,
    requests: 0
  },
  mutations: {
    updateRequests(state, type) {
      state.requests = type === 'dec' ? state.requests - 1 : state.requests + 1;
    },
    updateLawyer(state, lawyer) {
      state.item = lawyer;
    }
  },
  actions: {
    applyCss({ state }) {
      const css = state.item.custom_style_iframe_css;
      if (css && css.length !== 0) {
        const vars = JSON.parse(css);
        Object.keys(vars).forEach(key => {
          document.documentElement.style.setProperty(`--symplicy-${key}`, vars[key]);
        });
      }
    },
    // eslint-disable-next-line
    async getLawyer({ dispatch, commit }, uuid) {
      commit('updateRequests');
      const request = await dispatch('calls/lawyer', uuid, { root: true });

      if (request.status === 'success') {
        commit('updateLawyer', request.data.data);
        dispatch('applyCss');
      }

      commit('updateRequests', 'dec');
    }
  }
};

export default lawyer;
